import { render, staticRenderFns } from "./ErrorReport.vue?vue&type=template&id=c06f1f6c&"
import script from "./ErrorReport.vue?vue&type=script&lang=js&"
export * from "./ErrorReport.vue?vue&type=script&lang=js&"
import style0 from "./ErrorReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports